import { interval, Subject, Subscription } from 'rxjs';

// Timer is timer that counts down to zero from a given duration and is able to emit timeout events.
export class Timer {
    updateFrequencySeconds: number;
  
    timer$: Subscription;
    totalTimeSeconds: number;
    timeLeftSeconds: number;
    timeout$: Subject<void>;
  
    constructor (minutes: number, seconds: number, updateFrequencySeconds: number = 1) {
      this.totalTimeSeconds = minutes * 60 + Math.round(seconds);
      this.updateFrequencySeconds = updateFrequencySeconds;
      this.timeout$ = new Subject;
    }
  
    // start starts the timer countdown
    start(): void {
      const ticker$ = interval(this.updateFrequencySeconds * 1000)
  
      this.timer$ = ticker$.subscribe(elapsedTimeSeconds => {
        this.timeLeftSeconds = (this.totalTimeSeconds - elapsedTimeSeconds)
  
        if (this.timeLeftSeconds === 0) {
          this.timeout$.next();
          this.stop();
        }
      })
    }
  
    // stop stops the timer countdown
    stop(): void {
      this.timer$.unsubscribe();
      this.timeout$.unsubscribe();
    }
  
    // getSecondsLeft returns the number of seconds left in the timer
    getSecondsLeft(): number { 
      return this.timeLeftSeconds;
    }
  
    // onTimeout allows the subscription to timeout events
    onTimeout(): Subject<void> {
      return this.timeout$
    }
  }